export default __webpack_public_path__ + "static/logzio-metrics-63eafb3fe3c502de0f669470152c09b4.png";